import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
// import { MomentModule } from 'ngx-moment';
import { LoadingMeasuresErrorPopupComponent } from './components/loading-measures-error-popup/loading-measures-error-popup.component';
import { MyMeasuresApiService } from './my-measures-api.service';
import { MyMeasuresEffects } from './my-measures.effects';
import {
  myMeasuresInitialState,
  myMeasuresReducer
} from './my-measures.reducer';

export const metaReducers: MetaReducer<any>[] = [localStorageSyncReducer];

@NgModule({
  imports: [
    // MomentModule,
    IonicModule,
    StoreModule.forFeature('myMeasures', myMeasuresReducer, {
      metaReducers,
      initialState: myMeasuresInitialState
    }),
    EffectsModule.forFeature([MyMeasuresEffects])
  ],
  providers: [MyMeasuresApiService],
  declarations: [LoadingMeasuresErrorPopupComponent]
})
export class MyMeasuresStoreModule {}

export function localStorageSyncReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return localStorageSync({
    keys: ['selectedMeasure'],
    rehydrate: true,
    removeOnUndefined: true
  })(reducer);
}
